import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { AuthRoutingModule } from './auth-routing.routing';
import { AuthComponent } from './auth.component';
import { LogoutComponent } from './logout/logout.component';
import { HttpClientModule } from '@angular/common/http';
import { AlertComponent } from './_directives';
import { AuthGuard } from './_guards';
import { AlertService, AuthenticationService, UserService } from './_services';
import { ResetPasswordComponent } from 'pages/authentication/templates/reset-password/reset-password.component';
import { DirectivesModule } from 'helpers/directives/directives.module';

@NgModule({
  declarations: [
    AuthComponent,
    AlertComponent,
    LogoutComponent,
    ResetPasswordComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    AuthRoutingModule,
    HttpClientModule,
    DirectivesModule
  ],
  providers: [
    AuthGuard,
    AlertService,
    AuthenticationService,
    UserService
  ],
  exports: [
    AlertComponent,
  ],
  entryComponents: [AlertComponent],
})

export class AuthModule {
}



// WEBPACK FOOTER //
// ./src/app/pages/authentication/auth.module.ts